<div class="modal solid" id="SurveyModal">
  @if (stepNum > 0) {
    <div (click)="moveBack()" class="back" id="SignupBackButton"></div>
  }
  <div (click)="hide()" class="buttonBall close" id="EscZEndpointClose"></div>
  <div class="fullRow">
    <div class="title">
      <span>{{ step.title }}</span>
    </div>
    <div class="subtitle detail">
      {{ step.subTitleDetail }}
    </div>
    <div class="subtitle stepNumber">{{ step.subTitleStep }}</div>
    <div class="row selections">
      @for (selection of selections; track selection) {
        <div
          (click)="select(selection)"
          [ngClass]="{ selected: selection.selected }"
          class="selection"
          >
          <div class="selection-letter">{{ selection.letter }}</div>
          <div class="selection-text">{{ selection.text }}</div>
          @if (selection.showInput) {
            <input
              #otherInput
              (input)="otherInputChanged(otherInput.value)"
              [(ngModel)]="otherText"
              class="survey-other-input"
              tabindex="1"
              />
          }
        </div>
      }
    </div>
    <button
      (click)="next()"
      [disabled]="disableNext"
      [ngClass]="{ disabled: disableNext }"
      class="save next"
      id="NextButton"
      >
      {{ showSubmit ? 'Submit' : 'Next' }}
    </button>
  </div>
</div>
